import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitorRegistrationMasterdataComponent } from './component/visitor-registration-masterdata.component';
import { DictionaryModule } from '@sdbn/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from '@sdbn/tmc-common';
import { NumberplateInputModule } from '@sdbn/tmc-common';

import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
  declarations: [
    VisitorRegistrationMasterdataComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,

    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    NumberplateInputModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSlideToggleModule
  ]
})
export class VisitorRegistrationMasterdataModule { }
